import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { getSubtypeHeader } from '../../../utils/subTypeHeader';

export default function EntertainmentLeisureForm({ shopType, formState, setFormState }) {
  const subtype = shopType;
  const headerText = getSubtypeHeader(subtype);

  const handleCheckboxChange = (key, value) => {
    setFormState(key, value);
  };

  return (
    <div className="form-section">
      <h3 className="section-title">{headerText}</h3>

      {/* Gaming */}
      {subtype === 'EL_gaming' && (
        <>
          <div className="field">
            <label>Game subtypes</label>
            <InputText
              value={formState[`gamesubtypes_${subtype}`] || ''}
              onChange={(e) => setFormState(`gamesubtypes_${subtype}`, e.target.value)}
              placeholder="e.g. PC, Console, VR"
            />
          </div>

          <div className="field">
            <label>Game Equipment</label>
            <InputText
              value={formState[`gameEquipment_${subtype}`] || ''}
              onChange={(e) => setFormState(`gameEquipment_${subtype}`, e.target.value)}
              placeholder="e.g. Controllers, VR headsets"
            />
          </div>

          <div className="field">
            <label>Age Group</label>
            <InputText
              value={formState[`ageGroup_${subtype}`] || ''}
              onChange={(e) => setFormState(`ageGroup_${subtype}`, e.target.value)}
              placeholder="e.g. Kids, Teens, Adults"
            />
          </div>

        </>
      )}

      {/* Event Venues */}
      {subtype === 'EL_eventVenues' && (
        <>
          <div className="field">
            <label>Event subtype</label>
            <InputText
              value={formState[`eventsubtype_${subtype}`] || ''}
              onChange={(e) => setFormState(`eventsubtype_${subtype}`, e.target.value)}
              placeholder="e.g. Weddings, Conferences"
            />
          </div>

          <div className="field">
            <label>Venue Capacity</label>
            <InputNumber
              value={formState[`venueCapacity_${subtype}`] || 0}
              onValueChange={(e) => setFormState(`venueCapacity_${subtype}`, e.value)}
              placeholder="e.g. 100, 200"
            />
          </div>

          <div className="field">
            <label>Facilities Available</label>
            <InputText
              value={formState[`facilitiesAvailable_${subtype}`] || ''}
              onChange={(e) => setFormState(`facilitiesAvailable_${subtype}`, e.target.value)}
              placeholder="e.g. Sound System, Projectors"
            />
          </div>

          <div className="field">
            <label>Parking Availability</label>
            <Checkbox
              inputId={`parkingAvailable_${subtype}`}
              checked={formState[`parkingAvailable_${subtype}`] || false}
              onChange={(e) => handleCheckboxChange(`parkingAvailable_${subtype}`, e.checked)}
            />
            <label htmlFor={`parkingAvailable_${subtype}`} className="ml-2">Parking Available</label>
          </div>
        </>
      )}

      {/* Art / Music / Theater */}
      {subtype === 'EL_arts' && (
        <>
          <div className="field">
            <label>subtype of Art</label>
            <InputText
              value={formState[`artsubtype_${subtype}`] || ''}
              onChange={(e) => setFormState(`artsubtype_${subtype}`, e.target.value)}
              placeholder="e.g. Painting, Sculpture"
            />
          </div>

          <div className="field">
            <label>Performance subtype</label>
            <InputText
              value={formState[`performancesubtype_${subtype}`] || ''}
              onChange={(e) => setFormState(`performancesubtype_${subtype}`, e.target.value)}
              placeholder="e.g. Music, Theater"
            />
          </div>

          <div className="field">
            <label>Artists/Performers</label>
            <InputText
              value={formState[`artistsPerformers_${subtype}`] || ''}
              onChange={(e) => setFormState(`artistsPerformers_${subtype}`, e.target.value)}
              placeholder="e.g. Local Artists, International Performers"
            />
          </div>

          <div className="field">
            <label>Event Schedule</label>
            <InputText
              value={formState[`eventSchedule_${subtype}`] || ''}
              onChange={(e) => setFormState(`eventSchedule_${subtype}`, e.target.value)}
              placeholder="e.g. Weekends, Monthly"
            />
          </div>
        </>
      )}

      {/* Travel & Tourism */}
      {subtype === 'EL_travel' && (
        <>
          <div className="field">
            <label>Destinations</label>
            <InputText
              value={formState[`destinations_${subtype}`] || ''}
              onChange={(e) => setFormState(`destinations_${subtype}`, e.target.value)}
              placeholder="e.g. Beaches, Mountains"
            />
          </div>

          <div className="field">
            <label>Tour Package subtypes</label>
            <InputText
              value={formState[`packagesubtypes_${subtype}`] || ''}
              onChange={(e) => setFormState(`packagesubtypes_${subtype}`, e.target.value)}
              placeholder="e.g. Adventure, Family"
            />
          </div>

          <div className="field">
            <label>Booking Method</label>
            <InputText
              value={formState[`bookingMethod_${subtype}`] || ''}
              onChange={(e) => setFormState(`bookingMethod_${subtype}`, e.target.value)}
              placeholder="e.g. Online, In-person"
            />
          </div>

          <div className="field">
            <label>Tour Duration (Days)</label>
            <InputNumber
              value={formState[`tourDuration_${subtype}`] || 0}
              onValueChange={(e) => setFormState(`tourDuration_${subtype}`, e.value)}
              placeholder="e.g. 2, 7"
            />
          </div>
        </>
      )}
    </div>
  );
}
